const defecto = {
    testNodeClasses: 'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links',
    testNodeStyle: 'height: 10px !important; font-size: 20px; color: transparent; position: absolute; bottom: 0; left: -10000px;',
    testInterval: 51,
    testRuns: 4
};
export const adblockDetect = (options) => {
    options = merge(defecto, options || {});
    const testNode = createNode(defecto.testNodeClasses, defecto.testNodeStyle);
    const adblockDetected = isNodeBlocked(testNode);
    const result = testNode.parentNode && testNode.parentNode.removeChild(testNode);
    console.log('adblockDetected', adblockDetected);
    return adblockDetected;
};
const createNode = (testNodeClasses, testNodeStyle) => {
    var document = window.document;
    var testNode1 = document.createElement('div');
    testNode1.innerHTML = '&nbsp;';
    testNode1.setAttribute('class', testNodeClasses);
    testNode1.setAttribute('style', testNodeStyle);
    document.body.appendChild(testNode1);
    return testNode1;
};
const isNodeBlocked = (testNode2) => {
    return testNode2.offsetHeight === 0 || !document.body.contains(testNode2) ||
        testNode2.style.display === 'none' ||
        testNode2.style.visibility === 'hidden';
};
const merge = (defaults, options) => {
    var obj = {};
    for (const key in defaults) {
        if (key) {
            obj[key] = defaults[key];
            const result = options.hasOwnProperty(key) && (obj[key] = options[key]);
        }
    }
    return obj;
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Adblock.ts
// module id = 535
// module chunks = 0